import React from 'react';

function About(){
    return(
        <div className = "card">
                <h1 id="title">About Us</h1>
                
                <p data-aos="flip-left">Coming from school we have the habit of being provided with books and all the
                necsessary resources to start studying for the exams. In college it is not so. So to save your time in scrounging
                for resources and googling stuff, this site has compilation of everything you'll need for the smooth sailing 
                of your first year of college life. All the content which could be scavenged is here. If you want something to be added to the website, mail me 
                at <strong>yash.silver2110@gmail.com</strong>.I have also added a important links section for the websites and 
                stuff you all will need sonner or later. I hope sooner! This website was made by using <strong>HTML5, CSS3 Flexbox and Grid,
                ReactJS and AOS</strong>. Please leave a star at the <a href="https://github.com/yashverma2110/resourcehub.git">repository</a> if this website was
                useful.</p>

                <h3 data-aos="flip-left">How to deploy a site for free</h3>
                
                <iframe src="https://www.youtube.com/embed/h99wHsM8pJE" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

        </div>
    )
}

export default About;